import { type CtsModuleSpecsFragment } from '../../../../api/fragments/CtsModuleSpecs';
import { type PermissionValues } from '../../../../utilities/hasPermissions';
import CtsModuleTabAuthorization from './CtsModuleTabAuthorization';
import CtsModuleTabMain from './CtsModuleTabMain';
import { HeaderTabs } from './types';

type CtsModuleInnerPageProps = {
    activeTab: HeaderTabs;
    module: CtsModuleSpecsFragment;
    openCtsSettingDrawer: () => void;
    permissions: Pick<PermissionValues, 'hasUpdatePermission'>;
};

const CtsModuleInnerPage = ({ activeTab, module, openCtsSettingDrawer, permissions }: CtsModuleInnerPageProps) => {
    switch (activeTab) {
        case HeaderTabs.MainDetails:
            return (
                <CtsModuleTabMain
                    module={module}
                    openCtsSettingDrawer={openCtsSettingDrawer}
                    permissions={permissions}
                />
            );

        case HeaderTabs.Authorization:
            return <CtsModuleTabAuthorization module={module} />;

        default:
            return null;
    }
};

export default CtsModuleInnerPage;
